import { SearchIcon } from "@acto/web-common/components";
import { css, styled } from "@pigment-css/react";
import { forwardRef, InputHTMLAttributes } from "react";

interface ManagementSearchInputProps extends InputHTMLAttributes<HTMLInputElement> {
  searchValue?: string;
  onSearchChange?: (value: string) => void;
}

const Wrapper = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  width: "100%",
  height: "50px",
  backgroundColor: theme.managementView.colors.neutral[0],
  border: `1px solid ${theme.managementView.colors.neutral[8]}`,
  borderRadius: "50px",
  transition: "border-color 0.2s, color 0.2s",
  color: theme.managementView.colors.neutral[56],

  "&:focus-within": {
    borderColor: theme.managementView.colors.neutral[90],
    color: theme.managementView.colors.neutral[90],
  },
}));

const iconStyle = css(({ theme }) => ({
  position: "absolute",
  left: theme.managementView.spacing[16],
  display: "flex",
  alignItems: "center",
  pointerEvents: "none",
  color: "inherit",

  "& svg": {
    width: "20px",
    height: "20px",
  },
}));

const inputStyle = css(({ theme }) => ({
  width: "100%",
  height: "100%",
  padding: `${theme.managementView.spacing[16]} ${theme.managementView.spacing[16]} ${theme.managementView.spacing[16]} 44px`,
  fontFamily: theme.managementView.font.familySecondary,
  fontSize: theme.managementView.font.size[14],
  lineHeight: theme.managementView.font.lineHeight[120],
  letterSpacing: theme.managementView.font.letterSpacing.tight,
  fontWeight: theme.managementView.font.weight[440],
  color: "inherit",
  backgroundColor: "transparent",
  border: "none",
  borderRadius: "50px",
  outline: "none",

  "&::placeholder": {
    color: theme.managementView.colors.neutral[56],
  },
}));

export const ManagementSearchInput = forwardRef<HTMLInputElement, ManagementSearchInputProps>(
  ({ searchValue, onSearchChange, placeholder = "Suche", ...props }, ref) => {
    return (
      <Wrapper>
        <span className={iconStyle}>
          <SearchIcon />
        </span>
        <input
          ref={ref}
          type="text"
          placeholder={placeholder}
          value={searchValue}
          onChange={(e) => onSearchChange?.(e.target.value)}
          className={inputStyle}
          {...props}
        />
      </Wrapper>
    );
  },
);
